type Props = {
  value: number | null;
  currency: string | null;
};

export const GmvCell = ({ value, currency }: Props) => {
  const computedValue = value === null || value === undefined || value <= 0 ? 0 : value;
  const formatted = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency ?? "USD",
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(computedValue);
  return <span className="text-xs text-primary font-medium whitespace-nowrap">{formatted}</span>;
};
